<template>
  <div class="mt-72">
    <component
      :is="stepComponent"
      @changeComponent="changeComponent"
      @setDisableBy="setDisableBy"
      @submitHandler="submitHandler"
      @setPassword="setPassword"
      :model="model"
      :state="{
        passwordValidation,
        ttl,
        disableBy
      }"
    />
  </div>
</template>

<script>
import disableForm from "@/components/Auth/GoogleAuth/disableForm.vue";
import AuthService from "@/services/modules/authService";
import otpForm from "@/components/Auth/GoogleAuth/otpForm.vue";

export default {
  components: { disableForm },
  data() {
    return {
      stepComponent: disableForm,
      otpToken: "",
      disableBy: "mobile",
      password: "",
      passwordValidation: [
        () =>
          !!this.password ||
          this.$t("authPage.loginPage.password.validation.notEmpty"),
        v =>
          !/^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF]+$/.test(
            v.replace(/\s/g, "")
          ) || this.$t("authPage.loginPage.password.validation.notPersian")
      ],
      ttl: 0,
      model: {
        email: null,
        mobile: null
      }
    };
  },
  methods: {
    submitHandler() {
      const identifierKey = this.disableBy === "mobile" ? "mobile" : "email";
      const identifierValue =
        this.disableBy === "mobile" ? this.model.mobile : this.model.email;

      const data = {
        [identifierKey]: identifierValue,
        password: this.password
      };

      AuthService.sendOtpToDisableGA(data)
        .then(res => {
          const { expires_in, token } = res.data.data;
          this.otpToken = token;
          localStorage.setItem("otpToken", token);
          this.ttl = expires_in;
          this.changeComponent(otpForm);
        })
        .catch(err => {
          console.error("Error sending OTP:", err);
        });
    },
    setPassword(value) {
      this.password = value;
    },
    changeComponent(component) {
      this.stepComponent = component;
    },
    setDisableBy(value) {
      this.disableBy = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.mt-72 {
  margin-top: 72px;
}
</style>
